import styled from 'styled-components';
import { useQueryParamsHook } from '../../../../../../../utils/useQueryParamsHook';
import { useReturnExchangesValueContextHook } from '../../../../contexts/ReturnExchangesContext';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { CustomRatioImage } from '../../../../../../../components/image/CustomRatioImage';
import CustomSelect from '../../../../../../../components/select/default/v1/CustomSelect';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import CutstomRefInput from '../../../../../../../components/input/CustomInput';
import { useState } from 'react';
import { GlobalWegetDateSelectorModal } from '../../../../../../../global-wegets/global-weget-date-selector-modal';
import moment from 'moment';
import { useReturnExchangeArchivesValueContextHook } from '../../../../contexts/ReturnExchangeArchivesContext';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { useSelectedReturnExchangesActionsContextHook } from '../../../../contexts/SelectedReturnExchangesContext';

const StyledContainer = styled.div`
    margin: 0 0 12px;
    padding: 12px 14px;
    background: #ffffff;
    border: 1px solid #eceef1;
    border-radius: 10px;
    box-shadow: var(--shadow-xs);
`;

const StyledWrapper = styled.div`
    .flexible{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex-wrap: wrap;
        gap: 10px;
    }
`;

const StyledArchiveContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    .label{
        font-size: 11px;
        font-weight: 600;
        color: #9ca3af;
    }

    button{
        height: 32px;
        padding: 0 12px;
        border-radius: 7px;
        background: var(--primary);
        color: #fff;
        font-size: 13px;
        font-weight: 600;
        border: none;
        box-shadow: var(--shadow-xs);
        transition: filter 0.15s ease;

        &:hover{
            filter: brightness(0.95);
        }
    }
`;

const StyledDateRangeContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    .label{
        font-size: 11px;
        font-weight: 600;
        color: #9ca3af;
    }

    button{
        height: 32px;
        padding: 0 12px;
        border-radius: 7px;
        background: #ffffff;
        color: #374151;
        font-size: 13px;
        font-weight: 600;
        border: 1px solid #d5d9df;
        transition: all 0.15s ease;

        &:hover{
            background: #f6f8fb;
            border-color: #c2c7cf;
        }
    }
`;

const StyledSearchContainer = styled.div`
    .wrapper{
        display: flex;
        gap: 6px;
    }

    input{
        height: 34px;
        border-radius: 7px;
        border: 1px solid #d5d9df;
        width: 220px;
        padding: 0 10px;
        font-size: 13px;
        transition: border-color 0.15s ease, box-shadow 0.15s ease;

        &:focus{
            outline: none;
            border-color: var(--primary);
            box-shadow: 0 0 0 3px var(--accent);
        }
    }

    select{
        height: 34px;
        border-radius: 7px;
        border: 1px solid #d5d9df;
        width: 140px;
        font-size: 13px;
    }

    & button{
        width: 34px;
        height: 34px;
        border-radius: 7px;
        border: 1px solid #d5d9df;
        background: #ffffff;
        transition: all 0.15s ease;

        &:hover{
            background: #f6f8fb;
            border-color: #c2c7cf;
        }

        .icon-figure{
            width: 45%;
            height: 45%;
        }

        &.disabled{
            opacity: 0.2;
        }
    }
`;

const StyledPaginationContainer = styled.div`
    .wrapper{
        margin-top: 8px;
        display: flex;
        justify-content: flex-end;
        gap: 6px;
        align-items: center;

        & .page-number{
            font-size: 12px;
            font-weight: 600;
            color: #6b7280;
        }

        & button{
            width: 28px;
            height: 28px;
            border-radius: 7px;
            border: none;
            background: none;
            transition: background 0.15s ease;

            &:hover{
                background: #f1f3f5;
            }

            .icon-figure{
                width: 70%;
                height: 70%;
            }

            &.disabled{
                opacity: 0.2;

                &:hover{
                    background: none;
                }
            }
        }

        & .number{
            font-size: 12px;
            font-weight: 600;
            color: #374151;
        }
    }
`;

const StyledArchiveSelectorModalHeader = styled.div`
    padding: 10px;
`;

const StyledArchiveSelectorModalBody = styled.div`
    padding: 10px;
    .statusList{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;

        button{
            border-radius: 8px;
            font-weight: 600;
            transition: all 0.15s ease;

            &.selected{
                border-color: var(--primary);
                background: var(--accent);
                color: var(--accent-foreground);
            }

            &:hover{
                border-color: var(--primary);
            }
        }
    }
`;

const StyledArchiveSelectorModalFooter = styled.div`
    padding: 10px;
    display: flex;
    gap: 10px;

    button{
        border-radius: 8px;

        &.all{
            background: var(--soft);
            color: var(--soft-foreground);
            font-weight: 600;
            border: none;
        }

        &.selected{
            background: var(--primary);
            color: #fff;
            font-weight: 600;
            border: none;
        }
    }
`;

export function FragmentSearchAndPagination(props) {
    const queryParamsHook = useQueryParamsHook();
    const returnExchangeArchivesValueContextHook = useReturnExchangeArchivesValueContextHook();
    const selectedReturnExchangesActionsContextHook = useSelectedReturnExchangesActionsContextHook();
    const returnExchangesValueContextHook = useReturnExchangesValueContextHook();
    const returnExchangesPagination = returnExchangesValueContextHook?.pagination;

    const initialStartDate = moment(queryParamsHook?.params?.startDate || new Date()).format('YYYY-MM-DD');
    const initialEndDate = moment(queryParamsHook?.params?.endDate || new Date()).format('YYYY-MM-DD');
    const currentArchive = (queryParamsHook?.params?.archiveId && returnExchangeArchivesValueContextHook?.returnExchangeArchives) ? returnExchangeArchivesValueContextHook?.returnExchangeArchives?.find(item => item?._id === queryParamsHook?.params?.archiveId) : null;
    const currentReturnExchangeType = queryParamsHook?.params?.returnExchangeType ? RETURN_EXCHANGE_TYPES.find(item => item?.value === queryParamsHook?.params?.returnExchangeType) : null;
    const currentReturnExchangeProceedStatuses = queryParamsHook?.params?.returnExchangeProceedStatuses || [];

    const [searchCondition, setSearchCondition] = useState(queryParamsHook?.params?.searchCondition || 'RECEIVER'); // RECEIVER, RECEIVER_CONTACT1, ORDER_NUMBER1, WAYBILL_NUMBER, COLLECTION_WAYBILL_NUMBER
    const [searchQuery, setSearchQuery] = useState(queryParamsHook?.params?.searchQuery || '');

    const [dateSelectorModalOpen, setDateSelectorModalOpen] = useState(false);
    const [archiveSelectorModalOpen, setArchiveSelectorModalOpen] = useState(false);
    const [returnExchangeTypeSelectorModalOpen, setReturnExchangeTypeSelectorModalOpen] = useState(false);
    const [returnExchangeProceedStatusSelectorModalOpen, setReturnExchangeProceedStatusSelectorModalOpen] = useState(false);

    const handlePrevPage = () => {
        let newParams = {
            ...queryParamsHook.params,
            page: returnExchangesPagination?.prevPage
        };

        queryParamsHook.setSearchParams(newParams);
    }

    const handleNextPage = () => {
        let newParams = {
            ...queryParamsHook.params,
            page: returnExchangesPagination?.nextPage
        };

        queryParamsHook.setSearchParams(newParams);
    }

    const handleSearch = () => {
        let newParams = { ...queryParamsHook.params };

        newParams.searchCondition = searchCondition;
        newParams.searchQuery = searchQuery;
        newParams.page = 1;

        queryParamsHook.setSearchParams(newParams);
    }

    const handleRefreshSearch = () => {
        setSearchQuery('');
        const newParams = { ...queryParamsHook.params };

        delete newParams.searchCondition;
        delete newParams.searchQuery;
        delete newParams.page;

        queryParamsHook.setSearchParams(newParams);
    }

    const handleSelectDateRange = (value) => {
        let newParams = { ...queryParamsHook.params };

        setDateSelectorModalOpen(false);
        newParams.startDate = value.startDate;
        newParams.endDate = value.endDate;
        newParams.page = 1;

        queryParamsHook.setSearchParams(newParams);
    }

    const handleCheckAll = () => {
        selectedReturnExchangesActionsContextHook.selectedReturnExchanges.setValue(prev => {
            // returnExchangesValueContextHook?.returnExchanges 가 prev에 포함되어 있으면 생략, 없으면 추가
            if (returnExchangesValueContextHook?.returnExchanges.every(item => prev.includes(item))) {
                return prev.filter(item => !returnExchangesValueContextHook?.returnExchanges.includes(item));
            }
            return [...prev, ...returnExchangesValueContextHook?.returnExchanges];
        });
    }
    return (
        <>
            <StyledContainer>
                <StyledWrapper>
                    <div className='flexible' style={{ marginBottom: '10px' }}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <StyledArchiveContainer>
                                <div className='label'>보관함</div>
                                <CustomBlockButton
                                    type='button'
                                    onClick={() => setArchiveSelectorModalOpen(true)}
                                >{currentArchive?.name || '전체'}</CustomBlockButton>
                            </StyledArchiveContainer>
                            <StyledArchiveContainer>
                                <div className='label'>반품/교환 타입</div>
                                <CustomBlockButton
                                    type='button'
                                    onClick={() => setReturnExchangeTypeSelectorModalOpen(true)}
                                >{currentReturnExchangeType?.label || '전체'}</CustomBlockButton>
                            </StyledArchiveContainer>
                            <StyledArchiveContainer>
                                <div className='label'>진행상태</div>
                                <CustomBlockButton
                                    type='button'
                                    onClick={() => setReturnExchangeProceedStatusSelectorModalOpen(true)}
                                >
                                    {(currentReturnExchangeProceedStatuses && currentReturnExchangeProceedStatuses.length > 0) ?
                                        <>
                                            선택됨 ({currentReturnExchangeProceedStatuses?.split(',')?.length})
                                        </>
                                        :
                                        <>
                                            전체
                                        </>
                                    }
                                </CustomBlockButton>
                            </StyledArchiveContainer>
                        </div>
                        <StyledDateRangeContainer>
                            <div className='label'>조회범위</div>
                            <CustomBlockButton
                                type='button'
                                onClick={() => setDateSelectorModalOpen(true)}
                            >{initialStartDate} ~ {initialEndDate}</CustomBlockButton>
                        </StyledDateRangeContainer>
                    </div>
                    <div className='flexible'>
                        <StyledSearchContainer>
                            <form onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
                                <div className='wrapper'>
                                    <CustomSelect value={searchCondition} onChange={(e) => setSearchCondition(e.target.value)}>
                                        <option value={'RECEIVER'}>수취인명</option>
                                        <option value={'RECEIVER_CONTACT1'}>수취인 전화번호1</option>
                                        <option value={'ORDER_NUMBER1'}>주문번호1</option>
                                        <option value={'WAYBILL_NUMBER'}>송장번호</option>
                                        <option value={'COLLECTION_WAYBILL_NUMBER'}>회수송장번호</option>
                                    </CustomSelect>
                                    <CutstomRefInput
                                        type='text'
                                        value={searchQuery || ''}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <CustomBlockButton
                                        type='submit'
                                    >
                                        <div className='icon-figure'>
                                            <CustomRatioImage>
                                                <CustomRatioImage.Image src='/assets/icons/search_000000.svg' />
                                            </CustomRatioImage>
                                        </div>
                                    </CustomBlockButton>
                                    <CustomBlockButton
                                        type='button'
                                        onClick={() => handleRefreshSearch()}
                                    >
                                        <div className='icon-figure'>
                                            <CustomRatioImage>
                                                <CustomRatioImage.Image src='/assets/icons/replay_000000.svg' />
                                            </CustomRatioImage>
                                        </div>
                                    </CustomBlockButton>
                                </div>
                            </form>
                        </StyledSearchContainer>
                        <StyledPaginationContainer>
                            <div className='wrapper'>
                                <div>
                                    <CustomBlockButton
                                        type='button'
                                        onClick={() => handleCheckAll()}
                                    >
                                        <div className='icon-figure'>
                                            <CustomRatioImage>
                                                <CustomRatioImage.Image src='/assets/icons/checklist_default_000000.svg' />
                                            </CustomRatioImage>
                                        </div>
                                    </CustomBlockButton>
                                </div>
                                <div className='number'>
                                    총 {returnExchangesPagination?.totalCount}건
                                </div>
                                <div>
                                    <CustomBlockButton
                                        type='button'
                                        className={`${!returnExchangesPagination?.hasPrev ? 'disabled' : ''}`}
                                        disabled={!returnExchangesPagination?.hasPrev}
                                        onClick={() => handlePrevPage()}
                                    >
                                        <div className='icon-figure'>
                                            <CustomRatioImage>
                                                <CustomRatioImage.Image src='/assets/icons/arrowBack_default_000000.svg' />
                                            </CustomRatioImage>
                                        </div>
                                    </CustomBlockButton>
                                </div>
                                <div className='number'>{returnExchangesPagination?.page} / {returnExchangesPagination?.totalPage}</div>
                                <div>
                                    <CustomBlockButton
                                        type='button'
                                        className={`${!returnExchangesPagination?.hasNext ? 'disabled' : ''}`}
                                        disabled={!returnExchangesPagination?.hasNext}
                                        onClick={() => handleNextPage()}
                                    >
                                        <div className='icon-figure'>
                                            <CustomRatioImage>
                                                <CustomRatioImage.Image src='/assets/icons/arrowForward_default_000000.svg' />
                                            </CustomRatioImage>
                                        </div>
                                    </CustomBlockButton>
                                </div>
                            </div>
                        </StyledPaginationContainer>
                    </div>
                </StyledWrapper>
            </StyledContainer>

            {dateSelectorModalOpen &&
                <GlobalWegetDateSelectorModal
                    open={dateSelectorModalOpen}
                    onClose={() => setDateSelectorModalOpen(false)}
                    initialStartDateTime={new Date(initialStartDate)}
                    initialEndDateTime={new Date(initialEndDate)}
                    onAccept={(value) => handleSelectDateRange(value)}
                />
            }

            {archiveSelectorModalOpen &&
                <ArchiveSelectorModal
                    open={archiveSelectorModalOpen}
                    onClose={() => setArchiveSelectorModalOpen(false)}
                />
            }

            {returnExchangeTypeSelectorModalOpen &&
                <ReturnExchangeTypeSelectorModal
                    open={returnExchangeTypeSelectorModalOpen}
                    onClose={() => setReturnExchangeTypeSelectorModalOpen(false)}
                />
            }

            {returnExchangeProceedStatusSelectorModalOpen &&
                <ReturnExchangeProceedStatusSelectorModal
                    open={returnExchangeProceedStatusSelectorModalOpen}
                    onClose={() => setReturnExchangeProceedStatusSelectorModalOpen(false)}
                />
            }
        </>
    );
}

function ArchiveSelectorModal({
    open,
    onClose
}) {
    const queryParamsHook = useQueryParamsHook();
    const returnExchangeArchivesValueContextHook = useReturnExchangeArchivesValueContextHook();
    const archives = returnExchangeArchivesValueContextHook?.returnExchangeArchives;

    const handleSelect = (archive) => {
        let newParams = { ...queryParamsHook.params };

        newParams.page = 1;
        if (!archive) {
            delete newParams.archiveId;
            queryParamsHook.setSearchParams(newParams);
        } else {
            newParams.archiveId = archive?._id;

            queryParamsHook.setSearchParams(newParams);
        }

        onClose();
    }

    return (
        <CustomDialog
            open={open}
            onClose={onClose}
        >
            <StyledArchiveSelectorModalHeader>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>
                        보관함 선택
                    </CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={onClose} />
                </CustomDialog.Header>
            </StyledArchiveSelectorModalHeader>
            <StyledArchiveSelectorModalBody>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleSelect(null)}
                >
                    전체
                </CustomBlockButton>
                {archives?.map((item, index) => {
                    return (
                        <CustomBlockButton
                            key={item?._id}
                            type='button'
                            onClick={() => handleSelect(item)}
                        >
                            {item?.name}
                        </CustomBlockButton>
                    );
                })}
            </StyledArchiveSelectorModalBody>
        </CustomDialog>
    )
}

function ReturnExchangeTypeSelectorModal({
    open,
    onClose
}) {
    const queryParamsHook = useQueryParamsHook();

    const handleSelect = (returnExchangeType) => {
        let newParams = { ...queryParamsHook.params };

        newParams.page = 1;
        if (!returnExchangeType) {
            delete newParams.returnExchangeType;
            queryParamsHook.setSearchParams(newParams);
        } else {
            newParams.returnExchangeType = returnExchangeType;

            queryParamsHook.setSearchParams(newParams);
        }

        onClose();
    }

    return (
        <CustomDialog
            open={open}
            onClose={onClose}
        >
            <StyledArchiveSelectorModalHeader>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>
                        반품/교환 타입 선택
                    </CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={onClose} />
                </CustomDialog.Header>
            </StyledArchiveSelectorModalHeader>
            <StyledArchiveSelectorModalBody>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleSelect(null)}
                >
                    전체
                </CustomBlockButton>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleSelect('RETURN')}
                >
                    반품
                </CustomBlockButton>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleSelect('EXCHANGE')}
                >
                    교환
                </CustomBlockButton>
            </StyledArchiveSelectorModalBody>
        </CustomDialog>
    )
}

function ReturnExchangeProceedStatusSelectorModal({
    open,
    onClose
}) {
    const queryParamsHook = useQueryParamsHook();
    const returnExchangeProceedStatusesParam = queryParamsHook?.params?.returnExchangeProceedStatuses;
    const returnExchangeProceedStatuses = returnExchangeProceedStatusesParam?.split(',')

    const [selectedStatuses, setSelectedStatuses] = useState(returnExchangeProceedStatuses || []);

    const handleSelect = (status) => {
        setSelectedStatuses((prev) => {
            if (prev.includes(status)) {
                return prev.filter(item => item !== status);
            } else {
                return [...prev, status];
            }
        })
    }

    const handleConfirm = () => {
        let newParams = { ...queryParamsHook.params };
        if (selectedStatuses.length === 0) {
            delete newParams.returnExchangeProceedStatuses;
            queryParamsHook.setSearchParams(newParams);
        } else {
            newParams.returnExchangeProceedStatuses = selectedStatuses.join(',');
            queryParamsHook.setSearchParams(newParams);
        }
        onClose();
    }

    const handleConfirmSelectAll = () => {
        let newParams = { ...queryParamsHook.params };
        delete newParams.returnExchangeProceedStatuses;
        queryParamsHook.setSearchParams(newParams);
        onClose();
    }

    return (
        <CustomDialog
            open={open}
            onClose={onClose}
        >
            <StyledArchiveSelectorModalHeader>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>
                        반품/교환 타입 선택
                    </CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={onClose} />
                </CustomDialog.Header>
            </StyledArchiveSelectorModalHeader>
            <StyledArchiveSelectorModalBody>
                <div className='statusList'>
                    {RETURN_EXCHANGE_PROCEED_STATUSES?.map((item, index) => {
                        return (
                            <CustomBlockButton
                                key={item?.value}
                                type='button'
                                className={`${selectedStatuses?.includes(item?.value) ? 'selected' : ''}`}
                                onClick={() => handleSelect(item?.value)}
                            >
                                {item?.label}
                            </CustomBlockButton>
                        );
                    }
                    )}
                </div>
            </StyledArchiveSelectorModalBody>
            <StyledArchiveSelectorModalFooter>
                <CustomBlockButton
                    type='button'
                    className='all'
                    onClick={() => handleConfirmSelectAll()}
                >
                    전체조회
                </CustomBlockButton>
                <CustomBlockButton
                    type='button'
                    className='selected'
                    onClick={() => handleConfirm()}
                >
                    선택완료
                </CustomBlockButton>
            </StyledArchiveSelectorModalFooter>
        </CustomDialog>
    )
}

const RETURN_EXCHANGE_TYPES = [
    {
        value: 'RETURN',
        label: '반품'
    },
    {
        value: 'EXCHANGE',
        label: '교환'
    }
];

/*
PREPARING
COLLECTION_REQUEST
COLLECTING
COLLECTION_COMPLETE
INSPECTION_COMPLETE
PROCESSING_COMPLETE
RETURN_SHIPMENT
EXCHANGE_RE_SHIPMENT_PREPARATION
EXCHANGE_RE_SHIPMENT_COMPLETE
*/
const RETURN_EXCHANGE_PROCEED_STATUSES = [
    {
        value: 'PREPARING',
        label: '준비중'
    },
    {
        value: 'COLLECTION_REQUEST',
        label: '수거요청'
    },
    {
        value: 'COLLECTING',
        label: '수거중'
    },
    {
        value: 'COLLECTION_COMPLETE',
        label: '수거완료'
    },
    {
        value: 'INSPECTION_COMPLETE',
        label: '검수완료'
    },
    {
        value: 'PROCESSING_COMPLETE',
        label: '처리완료'
    },
    {
        value: 'RETURN_SHIPMENT',
        label: '반송'
    },
    {
        value: 'EXCHANGE_RE_SHIPMENT_PREPARATION',
        label: '교환재출고준비'
    },
    {
        value: 'EXCHANGE_RE_SHIPMENT_COMPLETE',
        label: '교환재출고완료'
    }
]